import { request } from './ChartConfigService';

// Reglas SQL por motor de base de datos (Athena, PostgreSQL, MySQL…): lo que
// el agente debe respetar al escribir consultas en cada dialecto. Viven en
// whisperbi-agent-management-strands (billing-admin/app.py, solo root) y
// aplican al chat, al Análisis Profundo y a la Generación de tableros.
// `expectedVersion` es la versión que se estaba editando: si otra persona
// guardó antes, el backend responde 409.
const SqlRulesService = {
  async getRules() {
    return request('/sql-rules', { method: 'GET' });
  },
  async saveRules(engine, rules, expectedVersion) {
    return request(`/sql-rules/${encodeURIComponent(engine)}`, {
      method: 'PUT',
      body: JSON.stringify({ rules, expected_version: expectedVersion })
    });
  },
  // Errores frecuentes del motor en los últimos `days` días (máximo 45).
  async getErrors(engine, days) {
    return request(`/sql-rules/${encodeURIComponent(engine)}/errors?days=${encodeURIComponent(days)}`, { method: 'GET' });
  },
  async resetRules(engine, expectedVersion) {
    return request(`/sql-rules/${encodeURIComponent(engine)}?expected_version=${encodeURIComponent(expectedVersion)}`, {
      method: 'DELETE'
    });
  }
};

export default SqlRulesService;
